import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {hasValidActiveRateMatrixCell} from './hasValidActiveRateMatrixCell';
import {isActiveLeasingCell} from './isActiveLeasingCell';

export function hasValidActiveLeasingCell(vehicleLeasingBody: SaveSaleVehicleLeasingBody) {
  return hasValidActiveRateMatrixCell(vehicleLeasingBody.rateMatrixCells, (cell) =>
    isActiveLeasingCell(vehicleLeasingBody, cell)
  );
}
